/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RodzajUlicyTyp {
  Ulica = 'ULICA',
  Plac = 'PLAC',
  Rondo = 'RONDO',
  Aleja = 'ALEJA',
  Skwer = 'SKWER',
  Inna = 'INNA'
}
